import { MenuItem, TextField ,Typography} from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import { useForm } from "react-hook-form";
import React,{useState,useEffect} from "react";
import { ITEM_HEIGHT, ITEM_PADDING_TOP } from "../../utils/constants/DropDownConstants";
import FaqModal from "./FaqModal";

export const CustomDropdown= (props)=>{
                           
    const{onChange,defaultValue,data,error,helperText,height,placeholder,initialValues,valueName,stateId,callApi} =props
   
    const [selectedValue, setSelectedValue] = useState(defaultValue );
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState("")

    useEffect(() => {
      // Update the selected value when the defaultValue changes
      const matchedOption = data.find((option) => option.name === defaultValue || option.bank_name === defaultValue);
      setSelectedValue(matchedOption || "");
    }, [defaultValue, data]);
  
  
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();

      //function to handle onChnage select
      const handleSelectChange = (event,data) => {
        setSelectedValue(event.target.value);
        onChange(event);
      };

      // Function to close the modal
    const closeModal = () => {
        callApi()
      setIsModalOpen(false);
  };

 
      //function to handle others
      const handleOtherCity = () => {
        setIsModalOpen(true)
        // props?.openModal()
      }
      
      //function to handle truncate text
      const truncateText = (text, maxLength) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
      };

      const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === 'Space') {
          e.preventDefault(); // Prevent the default Enter key behavior (form submission)
        }
      };

    return(
        <>
        <TextField
        fullWidth
        id="outlined-select-currency"
        select
        size="small"
        placeholder={placeholder}
        onKeyDown={handleKeyPress}
        error={!!error}
        helperText={helperText}
        onChange={(e) => handleSelectChange(e,data)}
        value={ selectedValue}
        sx={{
            "& .MuiInputBase-root": {
                height: height ? height : 65,
                borderRadius:"12px"
            },
        }}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: '150px',
               
              },
              
            },
          },
          // renderValue: () => (selectedValue ? truncateText(selectedValue.name, 20) : placeholder),
        }}     
      >
       
        {data.map((option) => {
            return (
              <MenuItem key={option.id} value={option} onClick={() => option.id === "others" ? handleOtherCity() : null}  >
               {/* {truncateText(  option.name, 20)}  */}
               {props?.fromName === "share" ? 
                 <>
                  {option.name}:-₹{option.value}
                 </> :
                 props?.fromName === "bankName" ? 
                 <>
                 {option?.bank_name}
                 </>
                 :
                 <>
                  {option.name} 
                 </>
              }
              
            </MenuItem>
            )
        }
        )}
      </TextField>
      <errors class="">
            <Typography variant="p5" mb={2}>
              {error?.message}
            </Typography> 
        </errors>
        <FaqModal open={isModalOpen} close={closeModal} stateIdValue={stateId}   data={modalData} option="addCity" />
      </>
    )
}